<template>
  <div class="all-whole">
    <navCom :navActive="navActive"></navCom>
    <div class="w clearfix" >
      <!--左侧导航 1start-->
      <user-nav ></user-nav>
      <!--左侧导航 end-->
      <!--右侧内容 2start-->
      <div class="user-main-right">
        <h2 class="user-order-title">申请退款</h2>
        <div class="user-main-right-center">
        <ul class="order-list-detail-main">
          <li>
            <table class="main-order-table">
              <tr>
                <th>商品详情</th>
                <th v-if="course_type==1">上课时间</th>
                <th>授课老师</th>
                <th>申请退款总金额</th>
              </tr>
              <tr>
                <td class="order-list-title" style="max-width: 130px;">{{course_name}}</td>
                <td style="max-width: 80px;" v-if="course_type==1">{{live_start_time}}至{{live_end_time}}</td>
                <td style="max-width: 130px;">{{teacher_name}}</td>
                <td style="width: 166px;">￥{{price}}</td>
              </tr>
            </table>
          </li>
        </ul>

        <h2 class="user-refund-title">退款原因</h2>
        <textarea class="refund-reason" placeholder="请输入退款原因，最多可输入200字" maxlength="200" v-model="desc"></textarea>
        <button class="refund-btn" @click="submit()">提交</button>
      </div>
      </div>
      <!--右侧内容 end-->
    </div>
    <footerCom></footerCom>
  </div>
</template>

<script>
  import UserNav from '.././components/user-nav.vue'
  import navCom from '../../components/welcome-nav'
  import footerCom from '../../components/foot'
  import tool from '../../assets/js/tool.js'
  import axios from 'axios'
  export default {
    name: "order-refund",
    data(){
      return{
        navActive:3,
        order_id:this.$route.query.order_id,
        data:{},
        refund_info:{},//退款信息
        desc:'',//退款原因
        tipShow:false,//弹窗
        course_name:'',//课程名称
        price:'',//价格
        live_start_time:'',//开始时间
        live_end_time:'',//结束时间
        order_status:'',//订单状态
        course_type:'',//课程状态
        teacher_name:'',//教师名称
      }
    },
    components: {
      UserNav,
      navCom,
      footerCom
    },
    methods:{
      /*** 提交事件1*/
      submit(){
        var that=this;
          let data = {
            user_id:this.$store.state.uuid,
            order_id: this.order_id,
            reason: this.desc
          };
        axios.post('/api/Center_Order/applyRefundPost' , data)
          .then(function (res) {
            if (res.data.code == 200) {
              that.$toast.center(res.data.msg);
              that.$router.go(-1);
              // that.$router.push({
              //     path: `/order-payment-detail`,
              //     query: {
              //       order_id: id
              //     },
              // });
            }
            /** 失败 : 0/3 **/
            else {
              /** 提示错误信息 : 0  **/
              if (res.data.code == 400) {
                that.$toast.center(res.data.msg);
              }
            }
          });
      },
      getOrder () {
        let data = {
          user_id:this.$store.state.uuid,
          order_id:this.order_id
        };
        tool.postData('Center_Order/applyRefund', data,(res) => {//线上课列表
          this.course_name=res.data.data.course_name;
          this.price=res.data.data.price;
          this.live_start_time=res.data.data.live_start_time;
          this.live_end_time=res.data.data.live_end_time;
          this.order_status=res.data.data.order_status;
          this.course_type=res.data.data.course_type;
          this.teacher_name=res.data.data.teacher_name;
        })
      },
    },
    mounted(){
      this.getOrder()
    }
  }
</script>

<style scoped>
  .w{
    width: 1200px;
    margin:0 auto ;
  }
  .fl{
    float: left;
  }
  .fr{
    float: right;
  }
  .all-whole{
    background: #fbfbfb;
    height: 100%;
  }
  .user-main-right{
    width: 1000px;
    float: right;
    height: 895px;
    background: #ffffff;
  }
  .user-order-title{
    width: 100%;
    height: 70px;
    line-height: 100px;
    box-sizing: border-box;
    border-bottom: 1px solid #e3e3e3;
    font-size: 18px;
    color: #252525;
    padding-left: 20px;
    font-weight: 500;
    margin-bottom: 23px;
  }
  .user-main-right-center{
    width: 954px;
    margin: 0 26px;
  }
  .user-main-right{
    width: 1000px;
    float: right;
    padding-bottom: 280px;
    box-sizing: border-box;
  }
  .user-order-title{
    width: 100%;
    border-bottom: 1px solid #e3e3e3;
    padding-bottom: 17px;
    font-size: 16px;
    color: #252525;
    font-weight: 500;
  }
  .main-order-title{
    height: 57px;
    display: flex;
    justify-content: space-between;
  }
  .main-order-title p{
    font-size: 14px;
    color: #2ea6a5;
    line-height: 65px;
  }
  .main-order-title span{
    font-size: 14px;
    color: #5c5c5c;
    line-height: 65px;
  }
  .main-order-table{
    width: 100%;
    border: 1px solid #e3e3e3;
    border-spacing: 0;
  }
  .main-order-table tr th{
    height: 47px;
    background: #f3f3f3;
    text-align: center;
    font-size: 14px;
    color: #717171;
    border-bottom: 1px solid #e3e3e3;
  }
  .main-order-table tr td{
    text-align: center;
    min-height: 58px;
    font-size: 14px;
    color: #8c8c8c;
    border-right: 1px solid #e3e3e3;
    padding: 15px 0;
  }
  .main-order-table tr td p{
    line-height: 20px;
  }
  .main-order-table tr td:last-child{
    border-right: none;
  }
  .main-order-table tr td.order-list-title{
    color: #414141;
    font-weight: 600;
  }
  .order-pay-btn{
    float: right;
    height: 50px;
    display: flex;
    justify-content: space-between;
    width: 226px;
    margin-top: 30px;
    cursor: pointer;
  }
  .order-pay-btn span{
    width: 100px;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    text-align: center;
    border-radius: 7px;
    color: #fff;
  }
  .order-pay-btn-hight-light{
    background: #ff9919;
  }
  .order-pay-btn-grey{
    background: #ccc;
  }
  .user-refund-title{
    width: 100%;
    padding-bottom: 17px;
    font-size: 16px;
    color: #252525;
    font-weight: 500;
    margin-top: 30px;
  }
  .refund-subtitle{
    font-weight: 600;
    color: #656464;
  }
  .refund-info{
    padding: 10px 26px;
    width: 260px;
  }
  .item-info{
    height: 36px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: #717171;
  }
  .refund-reason{
    width: 100%;
    height: 150px;
    background-color: #f3f3f3;
    border: 1px solid #e3e3e3;
    padding: 15px 17px;
    box-sizing: border-box;
  }
  .refund-reason::placeholder{
    color:#cacaca;
    font-size: 14px;
  }
  .refund-btn{
    height: 47px;
    width: 155px;
    background-color: #ff9919;
    color: #fff;
    line-height: 47px;
    text-align: center;
    font-size: 20px;
    border-radius: 5px;
    float: right;
    margin-top: 70px;
    border: none;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/order-list-detail.vue